import { Checkbox, Emails, FormGroup, Select } from 'components/common/form';
import { useReduxState } from 'hooks';
import { useFormState } from 'informed';

interface Props {
  onChange: () => void;
}

interface FormValues {
  summaryEmail: { [key: string]: boolean };
  summaryEmailEmailList: string[];
  enableSummaryEmail: boolean;
}

const SettingsSummaryEmail = ({ onChange }: Props) => {
  const { messages } = useReduxState();

  const formState = useFormState<FormValues>();

  const options = [
    {
      label: messages.commonTaskAnswers,
      value: 'taskAnswers',
      id: 'taskAnswers'
    },
    {
      label: messages.profileFeedbacks,
      value: 'feedbacks',
      id: 'feedbacks'
    },
    {
      label: messages.profileDiscussionComments,
      value: 'discussionComments',
      id: 'discussionComments'
    },
    {
      label: messages.profileChatMessages,
      value: 'chatMessages',
      id: 'chatMessages'
    },
    {
      label: messages.commonCourseCompletions,
      value: 'courseCompletions',
      id: 'courseCompletions'
    },
    {
      label: messages.courseAccessRequest,
      value: 'courseAccessRequests',
      id: 'courseAccessRequests'
    }
  ];

  return (
    <div>
      <Checkbox
        field="enableSummaryEmail"
        id="enableSummaryEmail"
        label={messages.settingsSummaryEmailSubscribe}
        onChange={onChange}
        style={{ marginTop: 5 }}
      />

      <FormGroup label={messages.commonRecipients}>
        <Emails
          disabled={!formState.values.enableSummaryEmail}
          field="summaryEmailEmailList"
          id="summaryEmailEmailList"
          onChange={onChange}
        />
      </FormGroup>

      <FormGroup label={messages.settingsSummaryEmailChooseEvents}>
        {options.map((option) => (
          <Checkbox
            disabled={
              !formState.values.enableSummaryEmail ||
              !formState.values.summaryEmailEmailList?.length
            }
            field={`summaryEmail.${option.value}`}
            id={`summaryEmail.${option.value}`}
            key={option.label}
            label={option.label}
            onChange={onChange}
            style={{ marginBottom: 5 }}
          />
        ))}
      </FormGroup>

      <FormGroup label={messages.settingsSummaryEmailFrequency}>
        <Select
          disabled={
            !formState.values.enableSummaryEmail ||
            !formState.values.summaryEmailEmailList?.length
          }
          field="summaryEmailFrequency"
          id="summaryEmailFrequency"
          label="Frequency"
          onChange={onChange}
          options={[
            { label: messages.settingsSummaryEmailFrequencyDay, value: 'day' },
            {
              label: messages.settingsSummaryEmailFrequencyWeek,
              value: 'week'
            },
            {
              label: messages.settingsSummaryEmailFrequencyMonth,
              value: 'month'
            }
          ]}
          style={{ maxWidth: 200 }}
        />
      </FormGroup>
    </div>
  );
};

export default SettingsSummaryEmail;
